import classNames from 'classnames';

import { Slot, useSlots } from '@xemplo/slot';

import { PromptBody } from './prompt-body';
import { PromptCloseButton } from './prompt-close-button';
import * as S from './prompt-dialog.styles';
import { PromptDialogSlot, PromptProps } from './prompt-dialog.types';
import { PromptFooter } from './prompt-footer';
import { PromptHeader } from './prompt-header';

export const PromptTestId = {
  container: 'prompt-dialog-container',
  header: 'prompt-dialog-header',
  body: 'prompt-dialog-body',
  footer: 'prompt-dialog-footer',
};

//Main container in charge of controlling layout of header, body, and footer
export function Prompt({ children, className, systemPrompt, extended }: PromptProps) {
  const slots = useSlots({ children });
  return (
    <S.PromptContainer
      data-testid={PromptTestId.container}
      className={classNames('prompt-container', className, {
        'system-prompt': systemPrompt,
        extended,
      })}
    >
      {!systemPrompt && slots[PromptDialogSlot.CloseButton]}
      <div data-testid={PromptTestId.header} className="header-container">
        {slots[PromptDialogSlot.Header]}
      </div>
      <div data-testid={PromptTestId.body} className="body-container">
        {slots[PromptDialogSlot.Body]}
      </div>
      <div data-testid={PromptTestId.footer} className="footer-container">
        {slots[PromptDialogSlot.Footer]}
      </div>
    </S.PromptContainer>
  );
}
Prompt.Slot = Slot;
Prompt.Header = PromptHeader;
Prompt.Body = PromptBody;
Prompt.Footer = PromptFooter;
Prompt.CloseButton = PromptCloseButton;
Prompt.Dialog = S.PromptDialogBase;
